import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🕊️ ¿Qué agrega el{' '}
            <span className="text-[#00C853]" data-id="element-78">
              Kit Adaptaciones Curriculares & Inclusión "Italiano Sin Barreras"
            </span>
            ?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés el material para el 80% del aula. El MegaPack +
            Adaptaciones resuelve el 20% que más tiempo te consume.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00C853]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d08] border-b border-[#00C853]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00C853]/30" data-id="element-83">
              Sin Adaptaciones
            </div>
            <div className="p-4 font-bold text-[#00C853] text-center border-l border-[#00C853]/30" data-id="element-84">
              Con Adaptaciones
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Valentina no puede hacer la actividad estándar del Congiuntivo
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Adaptaciones:
              </span>
              Improvisás algo "más fácil" en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-91">
                Con Adaptaciones:
              </span>
              Imprimís la Versione BASIC del Contenuto Specchio. 30 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Marcos necesita el examen diferente el día de la Verifica
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Adaptaciones:
              </span>
              Armás otra verifica el domingo a la noche
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-98">
                Con Adaptaciones:
              </span>
              Abrís la Valutazione Differenziata. Ya está lista.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              La directora pide ver el registro de adecuaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Adaptaciones:
              </span>
              Buscás algo que no encontrás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-105">
                Con Adaptaciones:
              </span>
              Mostrás la plantilla de seguimiento firmada. Profesional.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Tenés un alumno que termina en 2 minutos y se aburre
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Adaptaciones:
              </span>
              Le das más de lo mismo
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-112">
                Con Adaptaciones:
              </span>
              Le das la Versione PLUS del Contenuto Specchio. Desafío real.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Alumno con dislexia no puede leer la Spiegazione Visiva
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Adaptaciones:
              </span>
              Dictás o simplificás en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-119">
                Con Adaptaciones:
              </span>
              Imprimís la ficha de Lettura Facile. Ya está hecha.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-120">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-122">
                Situación:
              </span>
              Grupo con A2 y B1 juntos — no sabés a quién explicarle
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-123">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-124">
                Sin Adaptaciones:
              </span>
              Explicás al promedio y perdés a todos
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-125">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-126">
                Con Adaptaciones:
              </span>
              Usás el Protocollo Aula Aperta. Todos trabajan a la vez.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-127">
          ✅ EL KIT ADAPTACIONES INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-129">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-130">
              Sistema "Contenuto Specchio" (3 Velocidades)
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-131">
              La MISMA unidad del MegaPack en 3 versiones: BASIC / ESTÁNDAR /
              PLUS. Todos trabajan el mismo tema al mismo tiempo. Ningún alumno
              queda excluido. Ningún alumno se aburre.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-132">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-133">
              Lettura Facile (LF) — Italiano Accesible
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-134">
              6 textos de cultura italiana adaptados con reglas internacionales
              de accesibilidad lectora. Mismas ideas del tomo, menor carga
              cognitiva. Para alumnos con dislexia, TDAH o bajo nivel lector.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-135">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-136">
              Visual Learning Italiano — Fichas 100% Pictográficas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-137">
              6 fichas de gramática visual lista: ESSERE vs AVERE, Passato
              Prossimo, Gli Articoli, Il Congiuntivo, Le Preposizioni
              Articolate, Il Periodo Ipotetico. Para alumnos que no procesan el
              texto pero sí el diagrama.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-138">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-139">
              Valutazione Differenziata — Evaluaciones Listas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              4 versiones de verifica por nivel (APOYO / CRUCERO / VUELO /
              INCLUSIÓN) con criterios de calificación diferenciados. Nunca más
              armás otro examen el domingo a la noche.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-141">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-142">
              Guida d'Inclusione DSA/BES
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-143">
              Adaptaciones específicas por perfil: Dislexia / TDAH / Hipoacusia.
              Protocolos concretos para el aula de italiano. Comunicado de
              adaptación para familias listo para imprimir y firmar.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-144">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-145">
              Protocollo "Aula Aperta"
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-146">
              Sistema de estaciones de nivel. Cronograma de clase inclusiva de
              40/60 minutos. Regla 70/20/10 para gestionar tu atención. Para
              grupos donde conviven A2, B1 y B2 en el mismo espacio.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-147">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-148">
              Banco Slow-Track — El Camino Seguro
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-149">
              Plan de choque de 4 semanas para alumnos que ingresan sin base.
              Fichas de andamiaje completo. Sistema de Amigo Tutor. Para el
              alumno que llega a mitad de año sin haber visto italiano nunca.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-150">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-151">
              Pittogrammi d'Aula in Italiano
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-152">
              Set A: Instrucciones de clase (SCRIVI / ASCOLTA / PARLA / LEGGI /
              SILENZIO). Set B: Pictogramas de evaluación. Set C: Pictogramas de
              nivel por perfil. Para plastificar y pegar. Sin explicaciones en
              castellano.
            </p>
          </div>
        </div>
      </div>
    </section>;
}